import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Customize = function Customize(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 1a1 1 0 00-1 1v2a1 1 0 102 0h2a1 1 0 100-2h-2a1 1 0 00-1-1zM0 3a1 1 0 011-1h8v2H1a1 1 0 01-1-1zm0 5a1 1 0 011-1h2v2H1a1 1 0 01-1-1zm1 4a1 1 0 100 2h4v-2H1zm14-5H7v2h8a1 1 0 100-2zm-6 5h6a1 1 0 110 2H9a1 1 0 11-2 0v-2a1 1 0 112 0zM3 7a1 1 0 012 0v2a1 1 0 11-2 0V7z",
    fill: "currentColor"
  }));
};
export default Customize;